import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';


class FormAddress extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    initialValues: PropTypes.object,
  }

  render() {
    const { t } = this.props;
    return (
      <Form
        onSubmit={this.props.onSubmit}
        initialValues={this.props.initialValues}
        >{({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="" className="label">{t('street')}</label>
              <Field
                name="street"
                component="input"
                type="text"
                className="input"
              />
            </div>
            <div className="flex flex-col md:flex-row">
              <div className="flex-auto mr-2">
                <label htmlFor="" className="label">{t('postalCode')}</label>
                <Field
                  name="postalCode"
                  component="input"
                  type="text"
                  className="input"
                />
              </div>
              <div className="flex-auto">
                <label htmlFor="" className="label">{t('country')}</label>
                <div className="styled-select">
                  <Field
                    name="country"
                    component='select'
                    type="text"
                  >
                    <option value="ES">{t('countries.spain')}</option>
                    <option value="PT">{t('countries.portugal')}</option>
                  </Field>
                </div>
              </div>
            </div>
            <button type="submit" className="btn btn-blue">{t('btn.locateAddress')}</button>
          </form>
        )}
      </Form>
    );
  }
}

export default translate()(FormAddress);



// WEBPACK FOOTER //
// ./src/components/FormAddress.js